import {useRef, useEffect} from 'react'

type UseMount = () => boolean

const useMount: UseMount = () => {
  const mountedRef = useRef(false)

  useEffect(() => {
    mountedRef.current = true
  }, [])

  return mountedRef.current
}

export default useMount
